import styled from "styled-components";

export const Header = styled.div`
  background: #fff;
  grid-area: header;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--navbar-height);
  box-sizing: border-box;
  background: #fff;
  padding: 0 var(--sidebar-padding-x);
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
